module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-home u-relative u-force-3d u-bg--black-near",
    class: ['is-section-' + _vm.activeSectionID, _vm.isComingBackToSection ? 'is-coming-back-to-section' : ''],
    on: {
      "touchstart": _vm.onTouchDown,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd,
      "DOMMouseScroll": _vm.onMouseWheel,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('div', {
    staticClass: "p-home__landing p-home__section js-section u-fixed u-post-tl u-flex u-flex-ai--center u-fit-v",
    on: {
      "click": function($event) {
        !_vm.$root.isTouch ? _vm._onNextSection() : ''
      }
    }
  }, [_c('h1', {
    staticClass: "p-home__landing__logotype u-marg-l-w2of18 u-marg-l-w1of10@sm t-text--sm t-ffamily--freight u-w5of18 u-w7of10@sm u-color--white u-uppercase",
    class: [_vm.progressBarIsHidden ? 'is-visible' : 'is-hidden']
  }, [_c('span', {
    staticClass: "u-absolute u-pos-tl u-hide u-opacity--0 u-invisible u-overflow-h",
    staticStyle: {
      "width": "1px",
      "height": "1px"
    }
  }, [_vm._v("Immersive Garden")]), _vm._v(" "), _c('img', {
    staticClass: "u-force-3d u-fit-w u-opacity--55",
    attrs: {
      "src": "/static/medias/images/logotype.png",
      "alt": "Immersive Garden - Logotype",
      "title": "Immersive Garden - Logotype"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-home__landing__loader u-absolute u-pos-tl u-fit-h u-bg--white",
    class: [_vm.progressBarIsHidden ? 'is-hidden' : ''],
    style: ({
      'transform': 'scaleY(' + (_vm._casesVideosContainerRect.length / _vm.$casesVideos.length) + ') translateZ(0)'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-home__news p-home__section js-section js-news-container u-fixed u-post-tl u-flex u-flex-ai--center u-flex-jc--center u-fit-v"
  }, [_c('div', {
    staticClass: "u-absolute u-pos-tl u-zindex--1 u-fit",
    on: {
      "click": function($event) {
        !_vm.$root.isTouch ? _vm._onNextSection() : ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-zindex--2 u-flex u-flex-fd--column@sm u-w14of18 u-w8of10@sm u-color--white u-uppercase"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "p-home__news__title u-marg-t-md@sm t-link u-inline-block u-w11of14 u-fit-w@sm u-color--gray",
    attrs: {
      "href": _vm.news.url,
      "target": "_blank",
      "rel": "nofollow noreferrer noopener"
    }
  }, [_c('h2', {
    staticClass: "js-news-title t-text--xxl-l t-ffamily--freight"
  }, [_c('app-text-lines-separated', {
    attrs: {
      "text": _vm.news.title,
      "underligned": ""
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "p-home__cases p-home__section js-section js-section-cases u-relative u-marg-x-auto u-force-3d u-flex u-flex-jc--center u-fit-vw u-pad-x-w1of18 u-pad-x-0@sm"
  }, [_c('div', {
    staticClass: "u-force-3d u-fit-w"
  }, _vm._l((_vm.cases), function(c, index) {
    return _c('div', {
      staticClass: "p-home__cases__case u-force-3d u-flex u-flex-fd--column@sm"
    }, [_c('div', {
      staticClass: "u-relative u-flex u-flex-ai--center u-hide@sm u-w2of16"
    }, [_c('div', {
      staticClass: "p-home__cases__case__category js-case-category u-fit-w u-pad-r-w3of10"
    }, [(c.category) ? _c('span', {
      staticClass: "t-text--xxs t-fweight--bold u-color--gray u-uppercase",
      domProps: {
        "innerHTML": _vm._s(c.category.short_title)
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "u-flex u-flex-ai--center u-w13of16 u-fit-w@sm"
    }, [_c('router-link', {
      staticClass: "t-link u-relative u-flex u-flex-ai--center u-flex-ai--start@sm u-flex-fd--column@sm u-fit",
      attrs: {
        "to": _vm.$root.getCaseURLFromSlug(c.title_slug)
      }
    }, [_c('div', {
      staticClass: "u-relative u-w8of13 u-fit-w@sm u-overflow-h"
    }, [(c.cover.video) ? _c('div', {
      staticClass: "p-home__cases__case__media js-case-video-container u-relative"
    }, [_c('video', {
      staticClass: "js-case-video u-absolute u-pos-center u-fit-w",
      attrs: {
        "playsinline": "",
        "loop": "",
        "preload": "auto",
        "muted": "",
        "controls": _vm.$root.isTouch,
        "poster": c.cover_poster ? _vm.$root.CONFIG.env.uploads + c.cover_poster.path : '',
        "title": 'Immersive Garden - ' + c.title,
        "alt": 'Immersive Garden - ' + c.title
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "type": c.cover.mime
      }
    })]), _vm._v(" "), (!_vm.$root.isTouch) ? _c('div', {
      staticClass: "p-home__cases__case__media__overlay u-absolute u-pos-tl u-zindex--3 u-fit",
      class: [_vm.videosCanBePlayed.indexOf(index) !== -1 ? 'is-hidden' : '']
    }, [_c('div', {
      staticClass: "p-home__cases__case__media__overlay__loader u-absolute u-pos-br"
    }, [_c('div', {
      staticClass: "p-home__cases__case__media__overlay__loader-outer u-absolute u-pos-center u-bradius--circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "p-home__cases__case__media__overlay__loader-inner u-absolute u-pos-center u-bradius--circle"
    })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isTouch) ? _c('div', {
      staticClass: "p-home__cases__case__media__poster u-absolute u-pos-tl u-zindex--2 u-fit",
      class: [_vm.videosCanBePlayed.indexOf(index) !== -1 ? 'is-hidden' : ''],
      style: ({
        'background-image': 'url(' + (_vm.$root.CONFIG.env.uploads + c.cover_poster.path) + ')',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center'
      })
    }) : _vm._e()]) : (c.cover.image) ? _c('img', {
      staticClass: "js-case-image u-absolute u-pos-center u-fit-w",
      attrs: {
        "src": _vm.$root.CONFIG.env.uploads + c.cover.path,
        "title": 'Immersive Garden - ' + c.title,
        "alt": 'Immersive Garden - ' + c.title
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "u-relative u-marg-l-w1of13 u-marg-x-auto@sm u-marg-t-md@sm u-flex u-flex-ai--center u-w4of13 u-w8of10@sm"
    }, [_c('div', [_c('h3', {
      staticClass: "u-fit-w t-text--lg-l t-fweight--light t-ffamily--freight",
      domProps: {
        "innerHTML": _vm._s(c.title)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "u-marg-t-md u-hide@sm u-w9of10 t-text--xs2 t-lspacing--x-small u-color--gray",
      domProps: {
        "innerHTML": _vm._s(c.short_description)
      }
    }), _vm._v(" "), (c.category) ? _c('div', {
      staticClass: "p-home__cases__case__category-mobile u-marg-t-xxs t-text--xxs t-fweight--bold u-color--gray u-uppercase",
      domProps: {
        "innerHTML": _vm._s(c.category.title)
      }
    }) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "u-relative u-flex u-flex-ai--center u-flex-jc--end u-hide@sm u-w1of16"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "p-home__arrow-down u-fixed u-pos-bl u-click-area-xs u-cursor-pointer",
    class: [_vm.activeSectionID >= 2 ? 'is-hidden' : '', _vm.progressBarIsHidden ? 'is-visible' : 'is-hidden', _vm.activeSectionID < _vm.NB_SECTION - 1 ? 'is-visible' : 'is-hidden'],
    on: {
      "click": function($event) {
        _vm._onNextSection()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/medias/images/arrow-cursor.png",
      "alt": "Scroll Down",
      "title": "Scroll Down"
    }
  })]), _vm._v(" "), _c('app-cases-filter', {
    attrs: {
      "is-active": _vm.sectionFiltersIsVisible
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-w3of14 u-fit-w@sm"
  }, [_c('div', {
    staticClass: "p-home__news__subtitle"
  }, [_c('span', {
    staticClass: "t-text--xs-l t-fweight--bold u-uppercase u-color--gray-dark"
  }, [_vm._v("Latest news")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9ac796a"}!./src/scripts/components/page-home/template.html
// module id = 148
// module chunks = 0